import SignUpResponse from './SignUpResponse';
import './SignUpResponse.scss';

export default SignUpResponse;
